import { useTranslation } from 'react-i18next'
import { Placeholder } from '#components/Placeholder'
import { Select, type SelectEntry } from '#components/Select'

const usePriceSelectItems = () => {
  const { t } = useTranslation()

  return [
    { id: 'gross', value: t('settings.price-display.gross', 'Gross prices') },
    { id: 'net', value: t('settings.price-display.net', 'Net prices') },
    { id: 'no', value: t('settings.price-display.no', 'No prices') },
  ] as SelectEntry[]
}

export const AdditionalSettings = () => {
  const priceSelectItems = usePriceSelectItems()
  const { t } = useTranslation()

  return (
    <>
      <div className="_title">{t('settings.additional-settings', 'Additional Settings')}</div>
      <div className="_option">
        <Placeholder>
          <Select label={t('settings.price-display.header', 'Price Display')} value="gross" options={priceSelectItems} slim />
        </Placeholder>
      </div>
    </>
  )
}
